/**
 * Fills .wc-card-rating placeholders.
 * Uses wc-product-reviews.json when available; falls back to seeded values
 * so every product always shows a rating.
 */
(function () {
  var data = null;

  function getUrl() {
    return (typeof window.WC_REVIEWS_ASSET === 'string' && window.WC_REVIEWS_ASSET) || '';
  }

  function hash(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
    return Math.abs(h);
  }

  function seededRating(sku, id, handle) {
    var seed = String(sku) + '|' + String(id) + '|' + String(handle);
    var u = (hash(seed) % 1001) / 1000;
    var v = 4.2 + u * 0.6;
    v = Math.round(v * 10) / 10;
    if (v < 4.2) v = 4.2;
    if (v > 4.8) v = 4.8;
    return v;
  }

  function seededCount(sku, id, handle) {
    var seed = String(handle) + '|' + String(id) + '|' + String(sku);
    var u = hash(seed);
    return 12 + (u % 139); // count between 12 and 150
  }

  function stars(avg) {
    var n = Math.round(avg);
    var s = '';
    for (var i = 1; i <= 5; i++) {
      s += '<span style="color:' + (i <= n ? '#F5A623' : '#d4d4d4') + '">&#9733;</span>';
    }
    return s;
  }

  function normalizeSkuKey(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_|_$/g, '');
  }

  /** Exact keys first; then fuzzy SKU (vendor prefix / bundle suffix mismatches). */
  function pickEntry(products, sku, pid, handle, name) {
    if (!products) return null;
    if (sku && products[sku]) return products[sku];
    if (pid != null && products[String(pid)]) return products[String(pid)];
    if (handle && products[handle]) return products[handle];
    if (name && products[name]) return products[name];

    var needle = normalizeSkuKey(sku);
    if (!needle || needle.length < 4) return null;

    var best = null;
    var bestScore = -1;
    var bestCount = -1;
    var keys = Object.keys(products);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var entry = products[key];
      if (!entry || typeof entry.average !== 'number') continue;
      var norm = normalizeSkuKey(key);
      if (!norm) continue;
      var score = -1;
      if (norm === needle) score = 1000;
      else if (norm.endsWith('_' + needle)) score = 800;
      else if (norm.startsWith(needle + '_')) score = 600;
      else if (norm.indexOf('_' + needle + '_') !== -1) score = 400;
      else if (norm.indexOf(needle) !== -1) score = 200;
      if (score < 0) continue;
      var count = typeof entry.count === 'number' ? entry.count : ((entry.reviews && entry.reviews.length) || 0);
      if (score > bestScore || (score === bestScore && count > bestCount)) {
        bestScore = score;
        bestCount = count;
        best = entry;
      }
    }
    return best;
  }

  function handleFromProductUrl(url) {
    if (!url) return '';
    try {
      var path = url.indexOf('://') > -1 ? new URL(url).pathname : url;
      var match = path.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      var parts = String(url).replace(/\/$/, '').split('/');
      return parts[parts.length - 1] || '';
    }
  }

  function fillEl(el) {
    var sku = el.getAttribute('data-wc-sku') || '';
    var pid = el.getAttribute('data-pid') || '';
    var handle = el.getAttribute('data-wc-handle') || '';

    var r, c;
    var e = data && data.products ? pickEntry(data.products, sku, pid, handle) : null;

    if (e && typeof e.average === 'number') {
      // Real average from imported reviews — do not override with the seeded filler.
      r = e.average;
      c = typeof e.count === 'number' ? e.count : ((e.reviews && e.reviews.length) || 0);
      if (!c) c = seededCount(sku, pid, handle);
    } else {
      r = seededRating(sku, pid, handle);
      c = seededCount(sku, pid, handle);
    }

    el.removeAttribute('hidden');
    el.innerHTML =
      '<span class="wc-crate-st" aria-hidden="true">' + stars(r) + '</span>' +
      '<span class="wc-crate-avg" style="color:#C45500;font-weight:600;font-size:12px;margin-left:2px">' + r.toFixed(1) + '</span>' +
      '<span class="wc-crate-cnt" style="color:#007185;font-size:12px;margin-left:2px">(' + c + ')</span>';
  }

  function fillAll() {
    document.querySelectorAll('.wc-card-rating').forEach(fillEl);
  }

  // Injects real aggregateRating into collection ItemList from wc-product-reviews.json.
  function injectCollectionSchema() {
    var script = document.getElementById('wc-collection-schema');
    if (!script || !data || !data.products) return;

    try {
      var json = JSON.parse(script.textContent);
      if (!json.itemListElement || !json.itemListElement.length) return;

      json.itemListElement.forEach(function (listItem) {
        var product = listItem.item;
        if (!product || product['@type'] !== 'Product') return;

        var sku = product.sku || '';
        var handle = handleFromProductUrl(product.url);
        var name = product.name || '';
        var e = pickEntry(data.products, sku, null, handle, name);

        if (!e || typeof e.average !== 'number') return;

        var count = typeof e.count === 'number' ? e.count : ((e.reviews && e.reviews.length) || 0);
        if (count <= 0) return;

        product.aggregateRating = {
          '@type': 'AggregateRating',
          'ratingValue': Math.round(e.average * 10) / 10,
          'reviewCount': count
        };
      });

      script.textContent = JSON.stringify(json);
    } catch (err) {
      /* leave existing schema untouched if parsing fails */
    }
  }

  function injectProductSchema() {
    var script = document.getElementById('wc-product-schema');
    if (!script || !data || !data.products) return;

    var sku = script.getAttribute('data-sku') || '';
    var pid = script.getAttribute('data-pid') || '';
    var handle = script.getAttribute('data-handle') || '';
    var e = pickEntry(data.products, sku, pid, handle);

    if (!e || typeof e.average !== 'number' || !e.reviews || !e.reviews.length) return;

    try {
      var json = JSON.parse(script.textContent);
      /* Liquid already embeds AggregateRating for Google; only fill if missing. */
      if (json.aggregateRating && json.aggregateRating.reviewCount) {
        /* still merge review bodies below if absent */
      } else {
      var onsiteCount = parseInt(script.getAttribute('data-onsite-review-count'), 10) || 0;
      var onsiteSum = parseFloat(script.getAttribute('data-onsite-rating-sum')) || 0;

      var amazonCount = typeof e.count === 'number' ? e.count : e.reviews.length;
      var amazonSum = e.average * amazonCount;

      var combinedCount = onsiteCount + amazonCount;
      var combinedAvg = combinedCount > 0 ? (onsiteSum + amazonSum) / combinedCount : e.average;

      json.aggregateRating = {
        '@type': 'AggregateRating',
        'ratingValue': Math.round(combinedAvg * 10) / 10,
        'reviewCount': combinedCount
      };
      }

      var amazonReviews = e.reviews.slice(0, 10).map(function (rv) {
        var review = {
          '@type': 'Review',
          'author': { '@type': 'Person', 'name': rv.name || 'Verified Buyer' },
          'reviewRating': { '@type': 'Rating', 'ratingValue': rv.rating || e.average }
        };
        if (rv.text) review.reviewBody = rv.text;
        if (rv.date) review.datePublished = rv.date;
        return review;
      });
      json.review = (json.review || []).concat(amazonReviews);

      script.textContent = JSON.stringify(json);
    } catch (err) {
      /* leave existing schema untouched if parsing fails */
    }
  }

  function run() {
    var u = getUrl();
    if (!u) {
      fillAll();
      return;
    }
    fetch(u, { cache: 'no-cache' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        data = j;
        fillAll();
        injectProductSchema();
        injectCollectionSchema();
      })
      .catch(function () {
        fillAll();
      });
  }

  document.addEventListener('DOMContentLoaded', run);
  window.wcRefreshCardRatings = function () { fillAll(); };
})();
